import { SortFields } from "@/shared/environment/filter/filter-types";
import { SortOrder } from "@/shared/services/graphql/generated/consumer-graph-types";
import { Ref } from "vue";

export interface SortEntry {
    field: SortFields;
    order: SortOrder;
}

export interface SortOrderEntry {
    id: string;
    title: string;
    value: SortEntry;
}

/**
 * Checks whether an optional sort reference is ready to be sent with a query.
 *
 * A sort is either not used at all by a search, or it is provided but still undefined until the user
 * settings are loaded. Querying with an unresolved sort would request the results under a different
 * cache key and refetch them as soon as the setting arrives, which resets any running pagination.
 *
 * @param sort - The optional sort reference of a search.
 * @returns `true` if no sort is used or the provided sort has a value, otherwise `false`.
 */
export function isSortResolved(sort?: Ref<SortEntry | undefined>): boolean {
    return !sort || !!sort.value;
}
